import * as path from "../paths";
import { client } from "../client";

export const signup = (data) => {
  return client
    .post(path.SIGN_UP, data)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const signin = (data) => {
  return client
    .post(path.SIGN_IN, data)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const signout = () => {
  return client
    .post(path.SIGN_OUT)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
